<template>
  <div class="p-8">
    <div class="mx-auto max-w-5xl space-y-6">
      <div class="flex justify-start items-center gap-1">
        <svg
          @click="router.go(-1)"
          class="h-8 w-8 text-blue-600 hover:text-blue-700"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
          />
        </svg>
        <h1 class="text-3xl font-semibold">Add Crew</h1>
      </div>
      <form @submit.prevent="submitCrew" class="max-w-3xl space-y-5">
        <div class="text-lg space-y-5">
          <div>
            <label
              for="crew_name"
              class="block text-sm font-medium text-gray-600"
            >
              Name
            </label>
            <div class="mt-1">
              <input
                v-model="crew.crew_name"
                required
                maxlength="50"
                name="crew_name"
                class="w-full border rounded px-4 py-2"
              />
            </div>
          </div>

          <div>
            <label
              for="crew_description"
              class="block text-sm font-medium text-gray-600"
            >
              Description
            </label>
            <div class="mt-1">
              <textarea
                v-model="crew.crew_description"
                name="crew_description"
                class="w-full rounded border-gray-200 px-4 py-2"
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="pt-2 flex justify-center">
          <button
            type="submit"
            class="bg-blue-600 submit-btn text-white text-2xl font-bold w-60 rounded py-2 flex justify-center gap-2"
          >
            <div v-if="isPending" class="spinner"></div>
            Save
          </button>
        </div>

        <div v-if="error" class="text-center text-red-600 font-semibold">
          {{ error }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { timestamp } from "@/firebaseConfig";
import { useRoute, useRouter } from "vue-router";
import useCollection from "@/composables/useCollection";

export default {
  props: ["id", "user"],
  setup(props) {
    const isPending = ref(false);
    const route = useRoute();
    const router = useRouter();
    const business_id = props.user.claims.business_id ?? props.id;

    const { error, addDoc } = useCollection(`businesses/${business_id}/crews`);

    const crew = ref({});

    const submitCrew = async () => {
      isPending.value = true;
      await addDoc({
        createdAt: timestamp(),
        createdBy: props.user.uid,
        crew_name: crew.value.crew_name,
        crew_description: crew.value.crew_description ?? "",
      });
      isPending.value = false;
      if (!error.value) {
        router.push(route.path.substring(0, route.path.lastIndexOf("/")));
      }
    };

    return {
      router,
      error,
      crew,
      submitCrew,
      isPending,
    };
  },
};
</script>
